/* eslint-disable max-len */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable no-underscore-dangle */
/* eslint-disable prefer-destructuring */
import { transaction } from '@src/slide/domain/slide-app';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import TableModel from '@src/slide/domain/ui-model/element-modeles/table-model';
import ShapeModel from '@src/slide/domain/ui-model/element-modeles/shape-model';
import { observable, toJS } from 'mobx';
import GroupModel from '@src/slide/domain/ui-model/element-modeles/group-model';
import PictureModel from '@src/slide/domain/ui-model/element-modeles/picture-model';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import TextAdjustManager from '@src/slide/domain/ui-model/element-modeles/property/text/text-adjust';
import i18n from '@i18next/i18n';
import expect from '@src/slide/infrastructure/module/independent/assert/expect';
import { getReverseFontSize } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/text-level-map';
import _set from 'lodash/set';
import has from 'lodash/has';
import get from 'lodash/get';
import { updateFontScale } from '@src/slide/domain/ui-model/element-modeles/property/text/text-adjust/font-scale-adjust';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { copy } from '@src/slide/infrastructure/module/independent/object-operation';
import { MenuType } from '@src/slide/domain/ui-model/constant/menu';
import { SelectedEleMgrType } from '@src/slide/domain/selection/constant/select-element-type';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { isIframeShapeModel } from '@src/slide/domain/ui-model/elements/element-judge';
import { BORDER_SKETCH_KEY } from '@src/slide/domain/ui-model/element-modeles/property/border/constants';
import { TextConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/text/text-converter';
import ShapeBaseModel from '@src/slide/domain/ui-model/element-modeles/base-modeles/shape-base-model';
import { isImageConfigurableForShapeImageFill } from '@src/slide/domain/ui-model/element-modeles/property/fill/image-fill/is-image-configurable';
import BaseModel from '@src/slide/domain/ui-model/element-modeles/base-modeles/base-model';
import DataManage from '@src/framework/editor/src/page/index/components/editor/data';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { IFormatBrushManager, IFormatBrushServiceDelegates } from './interface';
import { FORMAT_BRUSH_TEXT } from './constant';
import { IAnimBrushManager } from '../../anim-brush/core/interface';

const ELEMENT_FITS_PROPS = {
    [UIModelType.SHAPE]: ['border', 'fillBackground', 'effect'],
    [UIModelType.CONNECTOR]: ['border'],
    [UIModelType.GROUP]: [],
    [UIModelType.IMAGE]: ['border', 'fillBackground', 'effect', 'alpha', 'image'],
    [UIModelType.TABLE]: [],
};

const IMAGE_FILL = 'style.fillBackground.image';    // 图片填充
const STYLE_IMAGE_PROPS = 'style.image';
const STYLE_ALPHA_PROPS = 'style.alpha';

export default class FormatBrushManager implements IFormatBrushManager {
    public readonly id = ActionType.FORMAT_BRUSH;

    @observable
    public formatBrushState: any = {
        data: null,
    };
    private _isContinuous = false;
    private services: IFormatBrushServiceDelegates;
    private animBrushManager: IAnimBrushManager;

    public constructor(services: IFormatBrushServiceDelegates) {
        this.services = services;
        this.initAnimBrushManager();
    }

    processMenuItemData(item: any, type: string) {
        if (type === MenuType.TOOLBAR || type === MenuType.QUICK_SETTING) {
            let tip = i18n.t('格式刷，双击可重复使用');
            let canDoubleClick = true;
            if (this.formatBrushState.data) {
                tip = i18n.t('退出格式刷(Esc)');
                canDoubleClick = false;
            }
            item.tipMsg = tip;
            item.canDoubleClick = canDoubleClick;
        }
        // 可写
        const value = !!this.formatBrushState.data;
        // 可读
        let support = false;
        const { selectedElements } = this.services.selectionService;
        if (selectedElements.length === 1) {
            const model = selectedElements.selectedArray?.[0];
            support = model instanceof TableModel || model instanceof ShapeModel || model instanceof PictureModel;
        }
        // 有权限
        item.enable = value || (support
            && this.services.userPriviledgeService.pptEditorState < PPTEditorStateType.COPYABLE);
    }
    processMenuItemValues(itemValues) {
        const value = this.formatBrushState.data;
        itemValues[ActionType.FORMAT_BRUSH] = value;
        return itemValues;
    }

    onClickButton() {
        if (this.formatBrushState.data) {
            this.onCancelBrush();
        } else {
            this.beginBrush();
            tdw({
                opername: 'doc_ppt',
                module: 'format_brush',
                action: 'thin',
            });
        }
    }
    public clearFormatBrushState = (): void => {
        if (this.formatBrushState.data) { // 有数据才清空，防止反复刷新
            this.formatBrushState = {
                data: null,
            };
        }
    };

    private beginBrush() {
        // Office 中存在动画刷时，格式刷不可用
        if (this.animBrushManager?.animBrushState) return;
        const props = this.getProps();
        if (props.textStyle || props.propNumber) {
            this.formatBrushState = props;
        }
        this.log(`copied ${JSON.stringify(props)} props`);
    }

    onDoubleClickButton() {
        this._isContinuous = true;
        this.beginBrush();
        tdw({
            opername: 'doc_ppt',
            module: 'format_brush',
            action: 'double',
        });
    }

    // 这个childModel没有用到，应该是迭代过程中造成的。为了不影响单测，这里加个"?"兼容新调用不需要传参。后面重构这块的时候再好好整理代码
    onElementSelectionMouseUp = () => {
        // Office 中，当同时存在动画刷和格式刷时，格式刷不作用
        if (this.animBrushManager?.animBrushState) {
            this.onCancelBrush();
            return;
        }
        if (this.formatBrushState.data) {
            if (this.services.userPriviledgeService.pptEditorState > PPTEditorStateType.EDITABLE) {
                this.services.tipsManager.showCannotEditTips();
            } else {
                this.applyStyle();
            }
            if (!this._isContinuous) {
                this.onCancelBrush();
            }
        } else {
            return;
        }
    };

    /**
     * 取消格式刷
     */
    onCancelBrush() {
        this._isContinuous = false;
        this.clearFormatBrushState();
    }
    /**
     * 读取来源对象的属性
     */
    // eslint-disable-next-line complexity
    getProps() {
        let data = 'shape';
        const srcProps = {};
        let propNumber = 0;
        let textStyle: any;
        let onlyText = false;
        const threeD = {};

        const { selectedElements } = this.services.selectionService;
        if (selectedElements.length) {
            let model = selectedElements.selectedArray?.[0] as any;

            if (model instanceof TableModel) {
                // 表格取第一个单元格的样式
                const table: TableModel = model as TableModel;
                let cell = table.tableItems[0][0];
                if (table.selectedCellRanges.length > 0) {
                    const first = table.selectedCellRanges[0];
                    cell = table.tableItems[first.rowStart][first.colStart];
                }
                model = cell;
                onlyText = true;
            }

            if (model?.editorInstance) {
                const { paragraphList, textBodyStyle } = model.editorInstance.getData();

                if (model.editorInstance.isEditing) {
                    // 编辑态只复制文字样式
                    const selectedText = model.editorInstance.getSelectionPara();
                    textStyle = this.getTextSytleData(selectedText);
                    onlyText = true;
                } else {
                    if (paragraphList[0]) {
                        paragraphList[0].para = true;

                        // canvas版本paragraphProps不包括paragraphCharacter，这里兼容一下
                        const { paragraphProps, paragraphCharacter } = paragraphList[0];
                        paragraphList[0].paragraphProps = {
                            ...paragraphProps,
                            ...paragraphCharacter,
                        };
                    }
                    textStyle = this.getTextSytleData(paragraphList);
                }

                textStyle = { ...textStyle, ...DataManage.getTextBodyStyle(textBodyStyle) };

                const wordArtPrstTxWarp = model.textBodyStyle?.bodyStyle?.prstTxWarp;

                if (wordArtPrstTxWarp) {
                    if (textStyle.bodyStyle) {
                        textStyle.bodyStyle.prstTxWarp = wordArtPrstTxWarp;
                    } else {
                        textStyle.bodyStyle = {
                            prstTxWarp: wordArtPrstTxWarp,
                        };
                    }
                }

                if (onlyText) {
                    data = FORMAT_BRUSH_TEXT;
                    return { data, textStyle };
                }
            }

            let propNames;
            if (isImageConfigurableForShapeImageFill(model)) {
                // 当形状为图片填充，并且能够设置图片效果等，格式刷需要支持图片属性
                propNames = ELEMENT_FITS_PROPS[UIModelType.IMAGE];
            } else {
                propNames = ELEMENT_FITS_PROPS[model.type] ?? [];
            }
            for (const name of propNames) {
                const value = model?.props?.style?.[name] ?? null;
                // borderProps需要单独处理一下
                if (name === 'border') {
                    _set(srcProps, `style.${name}`, this.getBorderProps(value));
                } else {
                    _set(srcProps, `style.${name}`, value);
                }
                propNumber += 1;
            }

            // 3d 属性
            model.scene3d && _set(threeD, 'scene3d', model.scene3d);
            model.shape3d && _set(threeD, 'shape3d', model.shape3d);
        }
        return { data, srcProps, propNumber, textStyle, threeD };
    }

    getBorderProps(border) {
        if (!border) return border;

        const isNoFill = !border.color && !border.gradFill && border.width === 0;
        // 无边框没有 color 这个字段，会导致无法覆盖目标 border.color 属性。这里在无边框的情况，增加 color:null 以覆盖原属性
        if (isNoFill) {
            return {
                ...border,
                color: null,
            };
        }

        return border;
    }

    getTextSytleData(paragraphList) {
        let firstTextP: any = null; //  包含第一个text的段落
        let firstP: any = null; //  第一个完整段落
        for (const p of paragraphList) {
            if (firstTextP === null) {
                const firstRun: Array<any> = [];
                const textRuns = p.textRuns;
                for (const run of textRuns || []) {
                    firstRun.push(run);
                    break;
                }
                firstTextP = { ...p };
            }
            if (p.para) {
                firstP = { ...p };
                break;
            }
        }
        const ts = DataManage.getTextRunStyle(firstTextP, 0);
        // console.log(ts);
        const ps = firstP ? DataManage.getParagraphStyle(firstP) : {};
        // console.log(ps);

        const textStyle = {
            textRunStyle: ts,
            paraStyle: ps,
        };
        return textStyle;
    }
    /**
     * 在目标对象上应用属性
     */
    // eslint-disable-next-line complexity
    applyStyle() {
        const { selectedElements } = this.services.selectionService;
        if (!selectedElements.length && !selectedElements.selectedArrayForType) {
            return;
        }
        const selectedSlideElements = selectedElements.selectedArrayForType(SelectedEleMgrType.SLIDE);

        if (this.isIframeSelectedElement(selectedSlideElements)) {
            return;
        }
        let { formatBrushState: brushState } = this;
        brushState = toJS(brushState);
        if (brushState.data === FORMAT_BRUSH_TEXT) {
            // 应用文字格式时，确保取到组合内的元素
            const target = selectedElements.selectedArray?.[0] as any;
            // table只能接受文字
            if (target instanceof TableModel) {
                const table: ITableModel = target as any;
                let hasChange = false;
                const items: Array<any> = [];
                table.props.items.forEach((rowInfo: Array<any>, row) => {
                    const tcList: Array<any> = [];
                    rowInfo.forEach((shape, col) => {
                        // 非合并的单元格才处理数据
                        const oldSelectedState = !shape.hMerge && !shape.vMerge
                            && table.cellSelectedState(row, col, table.selectedRange);
                        if (oldSelectedState) {
                            let uiModel: any = undefined;
                            if (shape.editorInstance) {
                                const srcData = shape.editorInstance.getData(true);
                                let selection = null;
                                if (shape.editorInstance.isEditing) {
                                    if (!shape.editorInstance.isExpanded()) {
                                        // 这个地方和dom版本有点区别（在编辑态）：
                                        // dom版本的逻辑：没有选区就更新整个cell（比如点下去不移动鼠标）
                                        // doc、office的表现保持一致：点下去不移动鼠标，这个时候选区是个光标，不做任何处理
                                        // 这里和doc、office保持一致，临时这么改，后面移除canvas判定的时候，一起重构下这里
                                        tcList.push(undefined);
                                        return;
                                    }

                                    selection = shape.editorInstance.getSelection();
                                }
                                // 3.0文本在ui-sdk时有一个清除非raw属性的操作，为了保证格式刷的属性能够保留下来，将所有的属性加上raw标签
                                Object.keys(brushState.textStyle || {}).forEach((p) => {
                                    if (expect(brushState.textStyle[p]).isObj()) {
                                        Object.keys(brushState.textStyle[p]).forEach((p1) => {
                                            brushState.textStyle[p][`raw-${p1}`] = true;
                                        });
                                    } else {
                                        brushState.textStyle[`raw-${p}`] = true;
                                    }
                                });
                                uiModel = DataManage.setStyleForTextBody(srcData, brushState.textStyle, selection);
                                uiModel.textBodyStyle = srcData.textBodyStyle; // textBodyStyle是Shape的属性，刷文字的时候不应该带上
                                hasChange = true;
                            }
                            tcList.push(uiModel);
                        } else {
                            tcList.push(undefined);  // undefined表示cell无变化
                        }
                    });
                    items.push(tcList);
                });
                if (hasChange) {
                    table.updateTableAllParagraphList({ items });
                }
                return;
            }
            // 只能应用到文字的编辑态中
            // 关于 使用loadsh.get和直接取值的方法，先全都保留原来的写法，防止隐藏bug，这些逻辑等这块后面完全移除老逻辑和重构的时候再整理干净
            const isEditing = target.editorInstance?.isEditing;
            const selection = target.editorInstance?.getSelection();

            if (isEditing && selection) { // 改为get，否则has取不到值
                if (!target.editorInstance.isExpanded()) {
                    // canvas下，会出现选择过程中选区是光标的情况（即未选中文字）
                    // 未选中文字的情况不应该应用格式刷的样式
                    return;
                }

                this.updateTextFontSize(target, brushState);
                const srcData = target.editorInstance.getData(true);
                const { paragraphList } = DataManage.setStyleForTextBody(srcData, brushState.textStyle, selection);
                this.commitChangeForEditing(target, srcData, paragraphList);
                return;
            }
        } else if (
            ((selectedSlideElements[0] as any).editorInstance && brushState.textStyle)
            || brushState.propNumber
        ) {
            // 文本 || 形状属性
            transaction(() => {
                // 形状样式，可以应用到整个组合。
                const target = selectedSlideElements[0];
                const items = this.getUpdateItems(target, brushState);

                for (const item of items) {
                    if (item.sdkProps) {
                        BaseModel.sdkV3UpdateAndRemoveProps(
                            item.element.sdkData,
                            item.sdkProps,
                            item.sdkRemoveProps,
                        );
                    }
                    if (item.sdkParagraph) {
                        const { txBody } = item.sdkParagraph;
                        ShapeBaseModel.sdkV3UpdateParagraphList(item.element.sdkData, txBody);
                    }
                    item.element.get3DProperty()?.updateShape3D(brushState.threeD.shape3d);
                    item.element.get3DProperty()?.updateScene3D(brushState.threeD.scene3d);
                }
            });
        }
    }

    private commitChangeForEditing(target, srcData, paragraphList) {
        transaction(() => {
            // 3.0文本在ui-sdk时有一个清除非raw属性的操作，为了保证格式刷的属性能够保留下来，将所有的属性加上raw标签
            TextConverter.addParagraphListRawSignProps(paragraphList, paragraphList);

            // textBodyStyle是Shape的属性，刷文字的时候不应该带上
            if (target.isPlFromMasterOrLayout) {
                target.updateMasterAndLayoutPlaceHolder(paragraphList);
            } else {
                target.updateParagraphList(paragraphList);
            }
        });
    }

    private updateTextFontSize(target, brushState) {
        const resizeLevel = target.editorInstance.getResizeLevel();
        if (!expect(resizeLevel).isNullOrUndefined()) {
            // 目标文字可能设置了自缩排进行了缩放，需要用其缩放比例来计算实际应用需要的字体大小
            const fontSize = getReverseFontSize(brushState?.textStyle?.textRunStyle?.fontSize, resizeLevel);
            if (fontSize) {
                _set(brushState, 'textStyle.textRunStyle.fontSize', fontSize);
            }
        }
    }

    private isIframeSelectedElement(selectedSlideElements) {
        return !selectedSlideElements.length || isIframeShapeModel(selectedSlideElements[0]);
    }

    getUpdateItems(model: any, brushState: any) {
        const items: any[] = [];
        const { borderSketchManager } = this.services;
        // eslint-disable-next-line complexity
        const getItemData = function (target: any) {
            let propNames;
            if (target.type === UIModelType.SHAPE && get(brushState.srcProps, IMAGE_FILL)
                && (has(brushState.srcProps, STYLE_IMAGE_PROPS) || has(brushState.srcProps, STYLE_ALPHA_PROPS))) {
                // 应用图片填充，且包含图片效果
                propNames = ELEMENT_FITS_PROPS[UIModelType.IMAGE];
            } else {
                propNames = ELEMENT_FITS_PROPS[target.type] ?? [];
            }
            const srcProps: any = { style: {} };
            let number = 0;
            for (const name of propNames) {
                if (has(brushState.srcProps, `style.${name}`)) {
                    const value = brushState.srcProps.style[name];
                    _set(srcProps, `style.${name}`, copy(value, true));
                    number += 1;
                }
            }
            if (target instanceof GroupModel) {
                for (const c of target.children) {
                    getItemData(c);
                }
            } else if (target instanceof ShapeModel && target.editorInstance && brushState.textStyle) {
                if (srcProps.style?.fillBackground?.grpFill) {
                    srcProps.style.fillBackground.grpFill = undefined;
                }
                const srcData = target.editorInstance.getData();
                // @ts-ignore
                const { paragraphList, textBodyStyle } = DataManage.setStyleForTextBody(srcData, brushState.textStyle);
                updateFontScale(target, { textBodyStyle, paragraphList });
                TextAdjustManager.getInstance().updateElementProps(target, srcProps, {
                    textBodyStyle,
                    paragraphList,
                });
                borderSketchManager.updatePathWithFormatBrush(target, srcProps.style);
                // @ts-ignore
                const copyProps = copy(srcProps, true, [BORDER_SKETCH_KEY]);
                const updateRemoveSdkProps = target.prepareUpdateAndRemoveSdkProps(copyProps);
                // 3.0文本在ui-sdk时有一个清除非raw属性的操作，为了保证格式刷的属性能够保留下来，将所有的属性加上raw标签
                TextConverter.addParagraphListRawSignProps(paragraphList, paragraphList);
                const sdkParagraph = target.prepareSDKParagraphListData(paragraphList, textBodyStyle);
                items.push({
                    element: target,
                    sdkProps: updateRemoveSdkProps.update,
                    sdkRemoveProps: updateRemoveSdkProps.remove,
                    sdkParagraph,
                });
            } else if (number > 0) {
                if (target instanceof PictureModel && srcProps.style?.image) {
                    const imageType = target.props?.imageType;
                    // 格式刷gif时，图片校正和图片效果不可被编辑
                    if (imageType === 'gif') {
                        srcProps.style.image = undefined;
                    } else if (imageType === 'svg+xml' || imageType === 'svg') { // 格式刷svg时，图片校正中的清晰度和图片效果不可被编辑
                        srcProps.style.image.colorTemperature = undefined;
                        srcProps.style.image.saturate = undefined;
                        srcProps.style.image.sharpenSoften = undefined;
                    }
                }
                // let sdkProps = target.prepareSDKPropsData(srcProps);
                borderSketchManager.updatePathWithFormatBrush(target, srcProps.style);
                // @ts-ignore
                const copyProps = copy(srcProps, true, [BORDER_SKETCH_KEY]);
                const updateRemoveSdkProps = target.prepareUpdateAndRemoveSdkProps(copyProps);
                items.push({
                    element: target,
                    sdkProps: updateRemoveSdkProps.update,
                    sdkRemoveProps: updateRemoveSdkProps.remove,
                });
            }
        };
        getItemData(model);
        return items;
    }

    log(msg) {
        console.log(`FormatBrush:${msg}`);
    }

    private initAnimBrushManager() {
        if (this.animBrushManager) return;
        this.services?.animBrushManager?.onDidInit((manager) => {
            this.animBrushManager = manager;
        });
    }
}
